import { render, staticRenderFns } from "./boss-tags.vue?vue&type=template&id=0ebdfcba"
import script from "./boss-tags.vue?vue&type=script&lang=js"
export * from "./boss-tags.vue?vue&type=script&lang=js"
import style0 from "./boss-tags.vue?vue&type=style&index=0&id=0ebdfcba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports